export const getIsReadOnly = (
  isStaff: boolean,
  isActAs: boolean,
  isSpamConversation: boolean
) => {
  return isStaff || isActAs || isSpamConversation
}

export const getIsConversationListEmpty = (
  conversations: Record<string, unknown>,
  fetching: string
) => {
  return (
    Array.from(Object.values(conversations)).length === 0 &&
    fetching === 'SUCCEED'
  )
}
